import { Typography } from "@material-ui/core";
import React from "react";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";

const RewardsPerLevelCard = ({ reward, deleteReward }) => {
	const typeHandler = () => {
		switch (reward.item.type) {
			case "discount":
				return (
					<>
						<Typography variant="body2">Descuento a {reward?.item?.itemDetails?.name}</Typography>
						<Typography variant="body2">Valor: {reward.item.amount} $</Typography>
					</>
				);
			case "freeDelivery":
				return (
					<>
						<Typography variant="body2">Envio gratis</Typography>
					</>
				);

			case "coupon":
				return (
					<>
						<Typography variant="body2">Cupón</Typography>
						<Typography variant="body2">Valor: {reward.item.amount} $</Typography>
					</>
				);
			default:
				return null;
		}
	};

	return (
		<div style={{ borderBottom: "1px solid #737373", margin: "10px 5px", paddingBottom: "5px" }}>
			<Typography variant="body1" style={{ fontWeight: 600 }}>
				{reward?.item?.name}
			</Typography>
			<Typography variant="body1">Cantidad: {reward?.amount}</Typography>
			{typeHandler()}
			<ButtonWithStyle onClick={deleteReward}>Borrar</ButtonWithStyle>
		</div>
	);
};

export default RewardsPerLevelCard;
